const RABBIT = {
    name: 'Rabbit',
    description: 'Un jeu dans lequel il faut aider un lapin à trouver des carottes.',
    technologies: ['Angular', 'HTML', 'TypeScript', 'CSS', 'IndexedDB', 'AngularMaterial'],
    firstReleaseDate: '17/04/2018'
};

export default RABBIT;
